import { useRollbar } from '@rollbar/react'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import {
  getReduxLogsData,
  getReduxLogs,
} from 'src/editor/store/redux-logging/redux-logging-selectors'
import { resetReduxLogData } from 'src/editor/store/redux-logging/redux-logging-actions'
import { useReduxLogging } from 'client/store'

export const useSentReduxLogsToRollbar = () => {
  const rollbar = useRollbar()
  const dispatch = useDispatch()
  const reduxLogging = useReduxLogging(getReduxLogsData)
  const reduxLogs = useReduxLogging(getReduxLogs)

  useEffect(() => {
    reduxLogging.forEach(
      ({ shouldBeSentToRollbar, message, resetReduxLogPayload }) => {
        if (shouldBeSentToRollbar) {
          rollbar.error(message, { logs: reduxLogs })
          dispatch(resetReduxLogData(resetReduxLogPayload))
        }
      },
    )
  }, [reduxLogging, rollbar, dispatch, reduxLogs])
}
